import * as gqlTypes from "@hydrologiq/gql-experience/graphql"
import RunDry from "@hydrologiq/shared/asset/attributes/RunDry"

interface SiteRunDryIconProps {
  site: gqlTypes.CustomerSite
  customerId: string
}

function SiteRunDryIcon({ site, customerId }: SiteRunDryIconProps) {
  const earliestRunDryMinutes = site.earliestInstallationRunDryMinutes
  const earliestRunDryAsset = site.earliestInstallationRunDryAsset

  return (
    <RunDry
      minutes={earliestRunDryMinutes ?? undefined}
      asset={earliestRunDryAsset ?? undefined}
    />
  )
}

export default SiteRunDryIcon
